import { createFileRoute } from '@tanstack/react-router'
import { ExamsPage } from '@/features/exams'

export const Route = createFileRoute('/exams')({
  component: ExamsPage,
})
